const thirdLayout = () => import(/* webpackChunkName: "third" */'@/components/third/ThirdLayout')
const thirdList = () => import(/* webpackChunkName: "third" */'@/components/third/ThirdList')
const thirdJoin = () => import(/* webpackChunkName: "third" */'@/components/third/ThirdJoin')
export default {
  path: 'third',
  component: thirdLayout,
  children: [
    {
      name: 'thirdList',
      path: 'thirdList',
      component: thirdList,
      meta: {
        module: 'third',
        keepAlive: true,
      },
    },
    {
      name: 'thirdJoin',
      path: 'thirdList/thirdJoin',
      component: thirdJoin,
      meta: {
        module: 'third',
        // keepAlive: true,
      },
    },
    {
      path: '/',
      redirect: {
        name: 'thirdList',
      },
    },
  ],
}



// WEBPACK FOOTER //
// ./src/router/third.js